type ItemWithOrderNo = {
    orderNo: string | number;
    [key: string]: any;
  };
  
  export const reorderByOrderNo = (data: ItemWithOrderNo[]): ItemWithOrderNo[] => {
    return data.sort((a, b) => parseInt(a.orderNo as string, 10) - parseInt(b.orderNo as string, 10));
  };

// Define the type for a single animation image object
interface CircularAnimationImage {
  normal: string;
  active: string;
  className: string;
}

// Export the typed array
export const landingPageCircularAnimationimages: CircularAnimationImage[] = [
  {
    normal: "https://d2nnrpx7gk2my2.cloudfront.net/files/6805dddec07d3d00087fec96/1.svg",
    active: "https://d2nnrpx7gk2my2.cloudfront.net/files/6805dde9c07d3d00087feca0/1.1.svg",
    className: "rotate-0",
  },
  {
    normal: "https://d2nnrpx7gk2my2.cloudfront.net/files/6805dde5c07d3d00087fec98/2.svg",
    active: "https://d2nnrpx7gk2my2.cloudfront.net/files/6805ddeac07d3d00087feca2/2.1.svg",
    className: "rotate-180",
  },
  {
    normal: "https://d2nnrpx7gk2my2.cloudfront.net/files/6805dde5c07d3d00087fec9a/3.svg",
    active: "https://d2nnrpx7gk2my2.cloudfront.net/files/68066132aa67f00008537d15/3.1.svg",
    className: "rotate-270",
  },
  {
    normal: "https://d2nnrpx7gk2my2.cloudfront.net/files/6805dde7c07d3d00087fec9c/4.svg",
    active: "https://d2nnrpx7gk2my2.cloudfront.net/files/6805ddebc07d3d00087feca6/4.1.svg",
    className: "rotate-90",
  },
];

interface TicketType {
  free: string;
  paid: string;
}

export const ticketType: TicketType = {
  free: "Free",
  paid: "Paid"
};